"use client";
import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { SectionHeading } from "@/components/common/decor";

const Stats = ({ stats }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <section ref={ref} className="relative overflow-hidden bg-cream bg-paper-grain py-20">
      <div aria-hidden className="pointer-events-none absolute -left-20 top-10 h-64 w-64 rounded-full bg-brand-200/30 blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-4">
        <SectionHeading
          eyebrow="By the Numbers"
          title="Our Achievements"
          description="A track record built one author, one title, and one launch at a time."
          className="mb-14"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {stats.map((item, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group relative overflow-hidden rounded-3xl border border-ink/10 bg-white p-8 text-center transition-all duration-400 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-editorial"
            >
              <span className="pointer-events-none absolute -right-2 -top-4 font-display text-8xl font-semibold text-ink/[0.04] transition-colors group-hover:text-gold/10">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="relative font-display text-4xl font-semibold text-brand-700 md:text-5xl">
                {inView ? (
                  <>
                    <CountUp start={0} end={parseInt(item.value)} duration={2} separator="," />
                    {item.value.replace(/[0-9]/g, "")}
                  </>
                ) : (
                  `0${item.value.replace(/[0-9]/g, "")}`
                )}
              </p>
              <span className="relative mx-auto mt-4 block h-px w-12 bg-gold/60 transition-all duration-500 group-hover:w-20" />
              <p className="relative mt-4 font-display text-lg font-semibold text-ink">{item.title}</p>
              <p className="relative mt-3 text-sm leading-relaxed text-ink-soft">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
